// @flow
import React, { Component } from 'react';
import { Form } from 'informed';

import PageHeader from '../../PageHeader.jsx';
import ContentBox from '../../ContentBox.jsx';

import GeneralInfo from './GeneralInfo.jsx';
import HouseHistory from './HouseHistory.jsx';
import HospitalizationHistory from './HospitalizationHistory.jsx';
import DietHistory from './DietHistory.jsx';
import SocialHistory from './SocialHistory.jsx';
import Allergies from './Allergies.jsx';
import SignificantHistory from './SignificantHistory.jsx';

class InformationHistoryPage extends Component<{}> {
  render() {
    return (
      <div>
        <PageHeader title="Basic Information" />
        <ContentBox title="General Information" id='generalInfo'>
          <Form component={GeneralInfo} autoComplete='off' />
        </ContentBox>
        <ContentBox title="Allergies" id='allergies'>
          <Allergies />
        </ContentBox>
        <ContentBox title="Significant History" id='significantHistory'>
          <SignificantHistory />
        </ContentBox>
        <ContentBox title="House History" id='houseHistory'>
          <HouseHistory />
        </ContentBox>
        <ContentBox title="Hospitalization History" id='hospHistory'>
          <HospitalizationHistory />
        </ContentBox>
        <ContentBox title="Diet History" id='dietHistory'>
          <DietHistory />
        </ContentBox>
        <ContentBox title="Social History" id='socialHistory'>
          <Form component={SocialHistory} autoComplete='off' />
        </ContentBox>
      </div>
    );
  }
}

export default InformationHistoryPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/informationHistory/InformationHistoryPage.jsx